/* ============================================================
   Vue "Par collection" — filtrage côté client
   - 'price-range:change' → met à jour les bornes prix
   - 'change' sur les radios Disponibilité → filtre par dispo (single-select avec désélection)
   ============================================================ */

(function () {
  if (typeof window === 'undefined') return;

  document.addEventListener('DOMContentLoaded', initGroupedView);

  function initGroupedView() {
    const view = document.querySelector('[data-grouped-view]');
    if (!view) return;

    const sidebar = document.querySelector('.collection-sidebar');
    if (!sidebar) return;

    const state = {
      priceMin: 0,
      priceMax: Number.POSITIVE_INFINITY,
      availabilityValue: null,
    };

    initStateFromInputs();
    setupAvailabilityRadios();
    applyFilters();

    sidebar.addEventListener('price-range:change', (e) => {
      state.priceMin = e.detail.min;
      state.priceMax = e.detail.max;
      applyFilters();
    });

    sidebar.addEventListener('change', (e) => {
      const target = e.target;
      if (!(target instanceof HTMLInputElement)) return;
      if (target.dataset.availabilityRadio === undefined) return;
      refreshAvailabilityState();
      applyFilters();
    });

    function initStateFromInputs() {
      const priceSlider = sidebar.querySelector('price-range-slider');
      if (priceSlider) {
        const rangeMax = parseFloat(priceSlider.dataset.rangeMax || '0');
        const currentMin = parseFloat(priceSlider.dataset.currentMin || '0');
        const currentMax = parseFloat(priceSlider.dataset.currentMax || rangeMax);
        state.priceMin = isNaN(currentMin) ? 0 : currentMin;
        state.priceMax = currentMax > 0 ? currentMax : rangeMax;
      }
      refreshAvailabilityState();
    }

    function refreshAvailabilityState() {
      const radios = sidebar.querySelectorAll('input[data-availability-radio]');
      let active = null;
      radios.forEach((r) => { if (r.checked) active = r.value; });
      state.availabilityValue = active;

      radios.forEach((r) => {
        const label = r.closest('[data-availability-label]');
        if (label) label.classList.toggle('active', r.checked);
      });
    }

    function setupAvailabilityRadios() {
      const radios = sidebar.querySelectorAll('input[data-availability-radio]');
      radios.forEach((radio) => {
        radio.addEventListener('mousedown', () => {
          radio._wasChecked = radio.checked;
        });
        radio.addEventListener('click', () => {
          if (radio._wasChecked) {
            radio.checked = false;
            radio._wasChecked = false;
            refreshAvailabilityState();
            applyFilters();
          }
        });
      });
    }

    function applyFilters() {
      const sections = view.querySelectorAll('[data-grouped-section]');
      let totalVisible = 0;

      sections.forEach((section) => {
        const items = section.querySelectorAll('[data-grouped-item]');
        let visibleInSection = 0;

        items.forEach((item) => {
          const price = parseFloat(item.dataset.productPrice || '0');
          const available = item.dataset.productAvailable === 'true';

          let visible = true;

          if (price < state.priceMin || price > state.priceMax) {
            visible = false;
          }

          if (visible && state.availabilityValue !== null) {
            if (state.availabilityValue === '1' && !available) visible = false;
            if (state.availabilityValue === '0' && available) visible = false;
          }

          item.classList.toggle('is-filtered-out', !visible);
          if (visible) visibleInSection++;
        });

        if (visibleInSection === 0) {
          section.hidden = true;
          section.classList.add('is-empty');
        } else {
          section.hidden = false;
          section.classList.remove('is-empty');
        }

        totalVisible += visibleInSection;
      });

      const emptyEl = view.querySelector('[data-grouped-empty]');
      if (emptyEl) emptyEl.hidden = totalVisible !== 0;
    }
  }
})();